import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React__default from 'react';
import { Button } from 'react-aria-components';

const buttonBase = "_button-base_hlu6r_1";
const styles = {
	buttonBase: buttonBase
};

const ButtonBase = (_a) => {
  var { children, className, isDisabled = false, isPending = false, size = "medium", variant = "primary" } = _a, props = __rest(_a, ["children", "className", "isDisabled", "isPending", "size", "variant"]);
  return React__default.createElement(Button, Object.assign({ "aria-busy": isPending, "aria-label": isPending ? "pending" : props["aria-label"], "aria-live": isPending ? "polite" : void 0, className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx(dynamicClassName, styles.buttonBase);
  }, "data-a11y-ignore": variant === "brand" ? "color-contrast" : void 0, "data-zds": true, "data-size": size, "data-variant": variant, isDisabled: isDisabled || isPending, isPending }, props), (buttonRenderProps) => typeof children === "function" ? children(buttonRenderProps) : children);
};

export { ButtonBase };
//# sourceMappingURL=ButtonBase.es.js.map
